import { inject } from 'vue';

const PLUGIN_KEY = Symbol('airjump-plugin');

export function providePluginContext(app, store) {
  const context = {
    store,
    getChat: () => store.getters.getSelectedChat,
    getContact: (id) => store.getters['contacts/getContact'](id),
    getPhone: () => {
      const chat = store.getters.getSelectedChat;
      const sender = chat?.meta?.sender;
      if (!sender) return '';
      return (sender.phone_number || sender.identifier || '')
        .replace(/^\+/, '').replace(/\D/g, '');
    },
    isMobile: () => window.innerWidth < 768,
  };
  app.provide(PLUGIN_KEY, context);
  return context;
}

export function usePluginContext() {
  const ctx = inject(PLUGIN_KEY, null);
  if (!ctx) {
    return { getChat: () => null, getContact: () => null, getPhone: () => '', isMobile: () => false, store: null };
  }
  return ctx;
}
